module.exports = __webpack_public_path__ + "media/assets/login/icon-piano-78dc19f5fb58d3089ca38ecb922113f2.svg";